import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

/**
 * A drag-and-drop file component that looks like PacingUploadExcel
 * but DOES NOT do any client-side Excel parsing. Once a file is
 * chosen or dropped, it simply calls onFileSelected(file).
 */
const FitToTAUploadExcel = forwardRef(({ onFileSelected }, ref) => {
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [fileName, setFileName] = useState('');

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragOver(false);
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      setFileName(file.name);
      onFileSelected?.(file);
      event.dataTransfer.clearData();
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files?.length > 0) {
      const file = event.target.files[0];
      setFileName(file.name);
      onFileSelected?.(file);
    }
  };

  // Optional: Expose a function for uploading a “sample” file
  useImperativeHandle(ref, () => ({
    processExternalFile: (file) => {
      setFileName(file.name);
      onFileSelected?.(file);
    },
  }));

  return (
    <div>
      <Card
        sx={{
          border: '2px dashed #ccc',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'border-color 0.3s',
          backgroundColor: isDragOver ? '#f0f0f0' : 'transparent',
          '&:hover': {
            borderColor: '#999',
          },
          mb: 2,
        }}
        onClick={handleBoxClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <CardContent>
          <Box sx={{ textAlign: 'center', color: '#666' }}>
            <CloudUploadIcon sx={{ fontSize: 48 }} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Upload Excel File
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Drag and drop an Excel file here or click to upload
            </Typography>
          </Box>
          <input
            type="file"
            accept=".xls,.xlsx"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </CardContent>
      </Card>
      {fileName && (
        <Typography variant="body2">Selected file: {fileName}</Typography>
      )}
    </div>
  );
});

export default FitToTAUploadExcel;